import { connect } from 'react-redux'
import { RootStateType } from 'store/store.ts'

export const Item = ({ name }: { name: string }) => <span>{name}</span>

export default (selector: (state: RootStateType) => { name: string }) => connect(selector)(Item)